import { useState } from 'react';

import cs from 'classnames';

import Icon from '../Icon/Icon';
import Typography from '../Typography/Typography';

const Accordion = ({
  title,
  rightContent = null,
  children,
  defaultOpen = false,
  className,
  contentClassName
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleAccordion = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div
      className={cs(
        'flex flex-col rounded-md border border-solid border-neutral-100 shadow-xs',
        className
      )}>
      <div
        className={cs(
          'flex h-[52px] cursor-pointer items-center justify-between gap-2 rounded-t-md border-0 border-b border-solid border-neutral-100 bg-white p-3 font-semibold',
          !isOpen && 'rounded-b-md border-b-0'
        )}
        onClick={toggleAccordion}>
        <Typography color="primary-900">{title}</Typography>
        <div className="flex items-center gap-3">
          {rightContent}
          <Icon icon={isOpen ? 'chevron-up-linear' : 'chevron-down-linear'} color="neutral" />
        </div>
      </div>
      <div
        className={cs(
          `flex flex-col gap-2 p-3 transition-all duration-300`,
          isOpen ? 'visible' : 'hidden',
          contentClassName
        )}>
        {children}
      </div>
    </div>
  );
};

export default Accordion;
